import { IActiveTask, IHorizonResource, TaskStatus } from '../types/operations.types'

export const MOCK_ACTIVE_TASKS: IActiveTask[] = [
  {
    id: 'task-147',
    name: 'Haul Cycle #147',
    machine: 'Truck 12',
    operator: 'Peter M.',
    status: TaskStatus.InProgress,
    statusLabel: 'In Progress',
    eta: '18m',
    location: 'Pit B to Crusher',
    source: 'PLAN',
    sourceId: 'plan-001',
    priority: 'High',
    assignee: 'Peter M.',
  },
  {
    id: 'task-148',
    name: 'Haul Cycle #148',
    machine: 'Truck 08',
    operator: 'Michael K.',
    status: TaskStatus.InProgress,
    statusLabel: 'Loading',
    eta: '6m',
    location: 'Pit B Loading',
    source: 'PLAN',
    sourceId: 'plan-001',
    priority: 'High',
    assignee: 'Michael K.',
  },
  {
    id: 'task-145',
    name: 'Haul Cycle #145',
    machine: 'Truck 03',
    operator: 'John S.',
    status: TaskStatus.Stopped,
    statusLabel: 'Blocked',
    location: 'Crusher Queue',
    source: 'PLAN',
    sourceId: 'plan-001',
    priority: 'Critical',
    assignee: 'John S.',
  },
  {
    id: 'task-exc-14',
    name: 'Excavation Segment 14',
    machine: 'CAT320',
    operator: 'Daniel R.',
    status: TaskStatus.InProgress,
    statusLabel: 'In Progress',
    eta: '34m',
    location: 'Zone B North',
    source: 'PLAN',
    sourceId: 'plan-002',
    priority: 'Critical',
    assignee: 'Daniel R.',
  },
  {
    id: 'task-146',
    name: 'Haul Cycle #146',
    machine: 'Truck 05',
    operator: 'Nicholas T.',
    status: TaskStatus.InProgress,
    statusLabel: 'Returning',
    eta: '22m',
    location: 'Haul Road',
    source: 'PLAN',
    sourceId: 'plan-001',
    priority: 'Medium',
    assignee: 'Nicholas T.',
  },
  {
    id: 'task-insp-22',
    name: 'Inspection #22',
    operator: 'Anna V.',
    status: TaskStatus.InProgress,
    statusLabel: 'In Progress',
    eta: '15m',
    location: 'Crusher Area',
    source: 'SHIFT_PROGRAM',
    priority: 'Medium',
    assignee: 'Anna V.',
  },
]

export const MOCK_HORIZON_RESOURCES: IHorizonResource[] = [
  {
    id: 'res-truck12',
    name: 'Truck 12',
    tasks: [
      { id: 'h-147', name: 'Haul #147', state: 'inProgress', durationMinutes: 45, startOffset: 0 },
      { id: 'h-152', name: 'Haul #152', state: 'assigned', durationMinutes: 45, startOffset: 45 },
      { id: 'h-158', name: 'Haul #158', state: 'proposed', durationMinutes: 45, startOffset: 90 },
      { id: 'h-ref', name: 'Refuel', state: 'proposed', durationMinutes: 30, startOffset: 135 },
    ],
  },
  {
    id: 'res-truck08',
    name: 'Truck 08',
    tasks: [
      { id: 'h-148', name: 'Haul #148', state: 'inProgress', durationMinutes: 45, startOffset: 0 },
      { id: 'h-153', name: 'Haul #153', state: 'assigned', durationMinutes: 45, startOffset: 45 },
      { id: 'h-159', name: 'Haul #159', state: 'proposed', durationMinutes: 45, startOffset: 90 },
    ],
  },
  {
    id: 'res-truck03',
    name: 'Truck 03',
    tasks: [
      { id: 'h-blk', name: 'Blocked', state: 'blocked', durationMinutes: 60, startOffset: 0 },
      { id: 'h-154', name: 'Haul #154', state: 'proposed', durationMinutes: 45, startOffset: 60 },
    ],
  },
  {
    id: 'res-truck05',
    name: 'Truck 05',
    tasks: [
      { id: 'h-146', name: 'Haul #146', state: 'inProgress', durationMinutes: 45, startOffset: 0 },
      { id: 'h-155', name: 'Haul #155', state: 'assigned', durationMinutes: 45, startOffset: 45 },
    ],
  },
  {
    id: 'res-cat320',
    name: 'CAT320',
    tasks: [
      { id: 'h-exc14', name: 'Excavation 14', state: 'inProgress', durationMinutes: 90, startOffset: 0 },
      { id: 'h-exc15', name: 'Excavation 15', state: 'assigned', durationMinutes: 90, startOffset: 90 },
    ],
  },
  {
    id: 'res-crewb',
    name: 'Crew B',
    tasks: [
      { id: 'h-insp1', name: 'Inspection', state: 'inProgress', durationMinutes: 60, startOffset: 0 },
      { id: 'h-insp2', name: 'Inspection', state: 'proposed', durationMinutes: 60, startOffset: 60 },
      { id: 'h-insp3', name: 'Inspection', state: 'proposed', durationMinutes: 60, startOffset: 120 },
    ],
  },
]
